angular.module('impactx.combibudget').controller('CombiBudgetEditCtrl', [
    '$routeParams',
    'dataGen',
    '$scope',
    'ToolbarService',
    'TranslationService',
    'ToastService',
    'BackService',
    'ConfirmationService',
    '$redirect',
    CombiBudgetEditCtrl
]);

function CombiBudgetEditCtrl($routeParams, dataGen, $scope, ToolbarService, TranslationService, ToastService, BackService, ConfirmationService, $redirect) {

    var ctrl = this;

    ctrl.get = function () {
        var data = {
            ctuId: $routeParams.id,
            mode: $routeParams.mode,
            usrId: $routeParams.usrId
        };
        dataGen.getData($scope, data, "/combibudget/edit").then(function () {
            defineButtons();
        });
    };

    ctrl.get();
    
    ctrl.canSave = function () {
        return $scope.data.canSave;
    };

    ctrl.save = function () {
        var dataObj = {
            data: $scope.data
        };
        return dataGen.postAsForm($scope, dataObj, "/combibudget/save").then(function () {
            BackService.back();
            ToastService.openStandardToast(TranslationService.get('saveSuccess'));
        });
    };

    ctrl.canDelete = function () {
        return $scope.data.ctuId > 0;
    };

    ctrl.deleteDialog = function () {
        ConfirmationService.showConfirmationDialog(ctrl.delete, event, TranslationService.get("deleteQuestionSingleObject"),
            TranslationService.get("delete"), TranslationService.get("abort"));
    };

    ctrl.delete = function () {

        var ids = [];

        for (var i = 0; i < $scope.data.combiBudgetCTTList.length; i++) {

            var budgets = [];

            switch ($scope.data.periodToShow.setId) {
                case 0:
                    budgets = $scope.data.combiBudgetCTTList[i].months;
                    break;
                case 1:
                    budgets = $scope.data.combiBudgetCTTList[i].years;
                    break;
                case 4:
                    budgets = $scope.data.combiBudgetCTTList[i].totals;
                    break;
            }

            for (var j = 0; j < budgets.length; j++) {
                ids.push(budgets[j].budgetId)
            }
        }

        var dataObj = {
            ctuId: $scope.data.ctuId,
            ids: ids
        };

        dataGen.getData($scope, dataObj, "/combibudget/delete").then(function () {
            BackService.back();
            ToastService.openStandardToast(TranslationService.get('deleteSuccess'));
        });
    };

    ctrl.remove = function (budgetId) {
        var dataObj = {
            ctuId: $scope.data.ctuId,
            ids: [budgetId]
        };

        dataGen.getData($scope, dataObj, "/combibudget/delete").then(function () {
            ToastService.openStandardToast(TranslationService.get('deleteSuccess'));
            $redirect.reload();
        });
    };

    function defineButtons() {
        var buttonDefinition = [
            {
                label: TranslationService.get('save'),
                action: ctrl.save,
                condition: ctrl.canSave,
                type: 'validation',
                params: {
                    form: $scope.dialogData
                }
            },
            {
                label: TranslationService.get('delete'),
                action: ctrl.deleteDialog,
                condition: ctrl.canDelete,
                type: 'dialogaction'
            }
        ];
        ToolbarService.setButtons(buttonDefinition);
    };

}